import gql from 'graphql-tag';

export default gql`
  query members($input: MemberQueryInput) {
    members(input: $input) {
      member {
        id
        personId
        firstName
        middleName
        lastName
        phoneNumber
        addressLine1
        addressLine2
        city
        state
        zipCode
        country
        emailAddress
        birthMonth
        birthDay
        birthYear
        spouseFirstName
        spouseMiddleName
        spouseLastName
        spouseBirthMonth
        spouseBirthDay
        spouseBirthYear
        spouseEmailAddress
        spouseId
        spanishMaterial
        accountIndicator
        accountType
        accountStatus
        expiryDate
        autoRenew
        membershipTerm
        cardSentDate
      }
      members {
        id
        firstName
        middleName
        lastName
        addressLine1
        city
        state
        zipCode
        emailAddress
        country
        birthMonth
        birthDay
        birthYear
      }
      matchCount
    }
  }
`;



// WEBPACK FOOTER //
// ./src/app/queries/memberSearch.js